import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import TermsService from '@/pages/TermsService'
import Product from '@/pages/Product'
import Feature from '@/pages/Feature'
import Profile from '@/pages/Profile'
import MyData from '@/pages/MyData'

Vue.use(Router)


let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/termsService',
      name: 'TermsService',
      component: TermsService
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/feature',
      name: 'Feature',
      component: Feature
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/invitation',
      name: 'Invitation',
      component: Profile
    },
    {
      path: '/mydata',
      name: 'MyData',
      component: MyData
    }
  ]
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
  // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
});

router.beforeEach((to, from, next) => {
  if (to.matched.length ===0) {  //如果未匹配到路由
    from.name ? next({ name:from.name }) : next('/');   //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  } else {
    next();    //如果匹配到正确跳转
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js